<template>
  <div
    id="actionplan"
    class="action-plan"
    v-if="
      satContent &&
        satContent.Tools &&
        currentAssessment &&
        currentAssessment.Id
    "
  >
    <div class="form-row cta-group">
      <a role="navigation" href="#" @click="routeToOverview()" @keydown.enter="routeToOverview()" class="back-assessment-link"
        ><span class="angle-circle-left-green"></span><div>Back to
        <strong>Saved assessments</strong></div></a
      >
    </div>

    <h1 class="page-title">{{ currentAssessment.Name }}</h1>
    <h4 class="title">Action plan</h4>
    <div class="row">
      <div class="col-lg-8">
        <div
          class="html-content"
          v-html="currentAssessment.ActionPlanIntroduction"
        ></div>
      </div>
    </div>
    <div class="form-row">
      <div class="col-12 d-flex flex-column flex-md-row">
        <!-- TODO: save and print functionality -->
        <div class="download dropdown show">
          <a role="button"
            name="actionplan-download"
            id="actionplan-actionplan"
            class="dropdown-toggle"
            :class="{ 'disabled': downloading }"
            href="#"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{downloadDropdownLabel}}
          </a>

          <div class="dropdown-menu" aria-labelledby="actionplan-actionplan">
            <div @click="saveAsPDF()" class="dropdown-item">Save as PDF</div>
            <div @click="saveAsExcel()" class="dropdown-item">Save as Excel</div>
            <div @click="printPDF()" class="dropdown-item">Print</div>
          </div>
        </div>
        <a role="navigation"
          class="feedback-link"
          :href="currentAssessment.FeedbackLinkUrl"
          :target="currentAssessment.FeedbackLinkTarget"
          >{{ currentAssessment.FeedbackLinkText }}</a
        >
      </div>
    </div>

    <div class="my-5">
      <h4 class="title">Action plan info</h4>
      <hr class="solid" />
      <div class="form-row">
        <div class="col-12 col-md-6 col-lg-3">
          <div class="name">Organisation name</div>
          <div class="body">{{ this.user.OrganisationName ? this.user.OrganisationName : "" }}</div>
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <div class="name">Contact name</div>
          <div class="body">
            {{
              (this.user.FirstName ? this.user.FirstName : "") +
                " " +
                (this.user.LastName ? this.user.LastName : "")
            }}
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <div class="name">Created on</div>
          <div class="body">{{ this.savedAssessmentDateCreated }}</div>
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <div class="name">Updated on</div>
          <div class="body">{{ this.dateUpdated }}</div>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-12 col-md-6">
        <h4 class="title">Action plan overview</h4>
      </div>
      <div class="col-12 col-md-6">
        <div class="name float-md-right">
          {{ currentAssessment.Standards.length }} Standard{{
            currentAssessment.Standards.length === 1 ? "" : "s"
          }}
        </div>
      </div>
    </div>

    <div>
      <div
        class="list-group mb-5"
        v-for="(standard, i) in currentAssessment.Standards"
        :key="standard.Id"
      >
        <ActionPlanStandard :standard="standard" :standardNumber="i + 1" />
      </div>
    </div>

    <a class="link-active float-right" @click="backToTop()"  @keydown.enter="backToTop()" tabindex="0">
      <span class="angle-square-up-green"></span>Back to top
    </a>
    <div class="space"></div>

    <ActionPlanPDFSave id="actionPlanPDFSave" ref="actionPlanPDFSave" :satId="satId" />    
    <ActionPlanPDFPrint id="actionPlanPDFPrint" ref="actionPlanPDFPrint" :satId="satId" />    
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { GET_SATCONTENTACTION, DOWNLOAD_SATREPORTACTION } from "../store/mutation-types";
import { privateRouter } from "../router";
import moment from "moment";
import ActionPlanStandard from "@/components/actionplan-standard";
import ActionPlanPDFSave from "@/components/actionplan-pdf-save";
import ActionPlanPDFPrint from "@/components/actionplan-pdf-print";

export default {
  name: "ActionPlan",
  components: {
    ActionPlanStandard,
    ActionPlanPDFSave,
    ActionPlanPDFPrint
  },
  data() {
    return {
      downloading: false
    };
  },
  props: {
    satId: {
      type: Number,
      default: () => 0
    }
  },
  async created() {
    await this.loadSatContent();
  },
  methods: {
    ...mapActions([GET_SATCONTENTACTION, DOWNLOAD_SATREPORTACTION]),
    async loadSatContent() {
      /* if(!this.satContent || !this.satContent.Tools){ // get satContent from API if not in the store (e.g. hitting this route before overview page)
                    await this.getSatContentAction();
                }  */

      // always get satContent from DB for action plan
      await this.getSatContentAction();
    },
    routeToOverview() {
      privateRouter.push({
        name: "SATs",
        query: {
          activeTab: 1
        }
      });
    },
    backToTop() {
      window.scrollTo(0, 0);
    },
    saveAsPDF() {
      this.$refs.actionPlanPDFSave.generateReport();
    },
    async saveAsExcel(){
      this.downloading = true;
      await this.downloadSatReportAction(this.satId);
      if(this.satExcelReport.constructor.name === 'Blob'){
      const today = new Date();
      const formattedDate = `${today.getDate()}-${today.getMonth() + 1}-${today.getFullYear()}`;
      const url = window.URL.createObjectURL(this.satExcelReport);
      var docUrl = document.createElement('a');
      docUrl.href = url;
      docUrl.setAttribute('download',this.currentAssessment.Name + ' Action Plan '+ formattedDate +'.xlsx');
      document.body.appendChild(docUrl);
      docUrl.click();
    }
    else{
      alert("Unable to download excel, please contact administrator");
    }
      this.downloading=false;
    },
    printPDF() {
      this.$refs.actionPlanPDFPrint.generateReport();
    }
  },
  computed: {
    ...mapState({
      satContent: state => state.satContent,
      user: state => state.users.user,
      satExcelReport: state => state.satExcelReport
    }),
    currentAssessment: {
      get() {
        return this.satContent && this.satContent.Tools && this.satId
          ? this.satContent.Tools.filter(tool => {
              return tool.Id === this.satId;
            })[0]
          : {};
      },
      set() {}
    },
    downloadDropdownLabel:{
      get(){
return this.downloading ? "Please wait, downloading..." : "Download action plan";
      },
      set() {}
    },
    dateUpdated() {
      // all responses are updated when saved, so just get the UpdatedDate of the first response (if it has ever been saved)
      return this.currentAssessment.Standards[0].Sections[0].Questions[0]
        .SAT_SavedResponses.Id
        ? // we have a saved response
          moment(
            this.currentAssessment.Standards[0].Sections[0].Questions[0]
              .SAT_SavedResponses.DateUpdated
          ).format("LL")
        : // response Id is null so assessment has never been saved
          "Assessment not saved";
    },
    savedAssessmentDateCreated() {
      return this.currentAssessment.SavedAssessmentDateCreated
        ? moment(this.currentAssessment.SavedAssessmentDateCreated).format("LL")
        : "Assessment not saved";
    }
  }
};
</script>

<style lang="sass" scoped></style>
